<h2 mat-dialog-title>{{ 'changePassword.title' | translate }}</h2>

<mat-dialog-content class="pt-3">
  <form [formGroup]="form" class="d-flex flex-column gap-2" (ngSubmit)="onSubmit()">

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'changePassword.oldPassword' | translate }}</mat-label>
      <input matInput [type]="showPassword ? 'text' : 'password'" formControlName="oldPassword">
      @if (form.get('oldPassword')?.hasError('required')) {
        <mat-error>
          {{ 'shared.required' | translate }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'changePassword.newPassword' | translate }}</mat-label>
      <input matInput [type]="showPassword ? 'text' : 'password'" formControlName="newPassword">
      @if (form.get('newPassword')?.hasError('required')) {
        <mat-error>
          {{ 'shared.required' | translate }}
        </mat-error>
      }
      @if (form.get('newPassword')?.hasError('minlength')) {
        <mat-error>
           {{ 'changePassword.minimumCharacters' | translate }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{ 'changePassword.confirmPassword' | translate }}</mat-label>
      <input matInput [type]="showPassword ? 'text' : 'password'" formControlName="confirmPassword">
      @if (form.get('confirmPassword')?.hasError('required')) {
        <mat-error>
          {{ 'shared.required' | translate }}
        </mat-error>
      }
      @if (form.get('confirmPassword')?.hasError('minlength')) {
        <mat-error>
           {{ 'changePassword.minimumCharacters' | translate }}
        </mat-error>
      }
      @if (form.get('confirmPassword')?.hasError('mismatch')) {
        <mat-error>
          {{ 'changePassword.passwordMismatch' | translate }}
        </mat-error>
      }
    </mat-form-field>

    <div class="d-flex align-items-center">
      <mat-checkbox [(ngModel)]="showPassword" [ngModelOptions]="{standalone: true}" color="primary">
        {{ 'changePassword.showPassword' | translate }}
      </mat-checkbox>
    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="close()">{{ 'shared.cancel' | translate }}</button>
  <button mat-flat-button color="primary" type="button" (click)="onSubmit()" [disabled]="isLoading">
    {{ 'shared.confirm' | translate }}
  </button>
</mat-dialog-actions>
